// @ts-nocheck
// =============================================================================
//  KitchenControl — Hint
//  Klein, herbruikbaar hint-balkje voor nieuwe gebruikers. Wegklikbaar; eenmaal
//  weggeklikt komt 'ie niet meer terug (onthouden in localStorage per id).
//
//  Gebruik:
//    import { Hint } from "./Hint";
//    <Hint id="mep-lijst" tekst="Tik een vakje aan om te plannen, nog eens voor 'klaar'." />
//
//  De localStorage-sleutel valt onder de "kc-"-prefix, zodat 'ie bij een
//  tenantwissel netjes mee gewist wordt (zie App.jsx). De hint is dus per
//  apparaat/gebruiker, niet per tenant — precies goed voor onboarding.
// =============================================================================
import { useState } from "react";
import { Lightbulb, X } from "lucide-react";

const C = {
  bg:   "#EFF6FF", // blauw-50
  bd:   "#BFDBFE", // blauw-200
  txt:  "#1E3A8A", // blauw-900
  icon: "#2563EB", // blauw-600
};

const SLEUTEL = (id) => `kc-hint-${id}`;

function isWeg(id) {
  try { return localStorage.getItem(SLEUTEL(id)) === "1"; } catch { return false; }
}
function zetWeg(id) {
  try { localStorage.setItem(SLEUTEL(id), "1"); } catch {}
}

// Alle hints weer terugzetten (handig tijdens testen / "rondleiding opnieuw").
export function resetHints() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k && k.startsWith("kc-hint-")) localStorage.removeItem(k);
    }
  } catch {}
}

export function Hint({ id, tekst, children, style }) {
  const [weg, setWeg] = useState(() => isWeg(id));
  if (weg) return null;

  const sluit = () => { zetWeg(id); setWeg(true); };

  return (
    <div style={{
      display: "flex", alignItems: "flex-start", gap: 10,
      background: C.bg, border: `1px solid ${C.bd}`, borderRadius: 10,
      padding: "10px 12px", margin: "0 0 12px", ...style,
    }}>
      <Lightbulb size={16} color={C.icon} style={{ flexShrink: 0, marginTop: 1 }} />
      <div style={{ flex: 1, fontSize: 12.5, lineHeight: 1.5, color: C.txt }}>
        {tekst || children}
      </div>
      <button onClick={sluit} aria-label="Hint sluiten"
        style={{ background: "none", border: "none", cursor: "pointer", color: C.icon, padding: 2, display: "flex", flexShrink: 0, opacity: 0.7 }}
        onMouseEnter={(e) => { e.currentTarget.style.opacity = 1; }}
        onMouseLeave={(e) => { e.currentTarget.style.opacity = 0.7; }}>
        <X size={15} />
      </button>
    </div>
  );
}

export default Hint;